<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-10" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Wie war Ihr Selbstmanagement in der letzten Woche?</span>
        </header>

        <div class="form-input-wrapper has-gradient">
            <div :class="['form-input-wrapper-scroll', {'scrolled': scrollPosition > 0}]" ref="scrollDiv">
                <div v-for="radio in radioList" :key="radio.name" class="form-input-radio-list">
                    <div class="form-input-radio-list-inner">
                        <span>{{ radio.label }}</span>

                        <div class="radio-list-wrapper form-input-radio form-input-radio--check">
                            <div v-for="(n, index) in 8" :key="index" class="radio-wrapper">
                                <input
                                    :id="radio.name + '-' + index"
                                    type="radio"
                                    :name="radio.name"
                                    :value="index"
                                    :checked="index === radio.value"
                                />
                                <label class="label-static" :for="radio.name + '-' + index" @click="clickOnRadio(radio.name)">{{ index }}</label>
                            </div>
                        </div>
                    </div>

                    <form-input-error v-if="errors && errors[radio.name] && errors[radio.name] !== null" :error="errors[radio.name][0]" :style="'margin-left:'+scrollPosition+'px'"></form-input-error>
                </div>
            </div>

            <span class="form-input-title new-text-xl text-bold">Haben Sie in den letzten SIEBEN TAGEN eine Zigarette – auch nur einen Zug – geraucht?</span>

            <div class="input-wrapper">
                <div class="form-input-radio-button-wrapper-two-columns">
                    <div 
                        :class="['form-input-radio-button-big', { 'active': smoking == true }]"
                        id="yes"
                        @click="smoking = true"
                        >
                        <div class="form-input-radio-button-inner">
                            <figure class="form-input-radio-button-icon">
                                <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.9912 31.3305C24.4562 31.3305 31.3184 24.4682 31.3184 16.0031C31.3184 7.53807 24.4562 0.675781 15.9912 0.675781C7.52627 0.675781 0.664062 7.53807 0.664062 16.0031C0.664062 24.4682 7.52627 31.3305 15.9912 31.3305Z" fill="#54DBA3"/>
                                <path d="M16 32.0003C7.17759 32.0003 0 24.8227 0 16.0002C0 7.17767 7.17759 0 16 0C24.8224 0 32 7.17767 32 16.0002C32 24.8227 24.8224 32.0003 16 32.0003ZM16 1.34565C7.91975 1.34565 1.34435 7.91983 1.34435 16.0015C1.34435 24.0831 7.91847 30.6573 16 30.6573C24.0815 30.6573 30.6556 24.0831 30.6556 16.0015C30.6556 7.91983 24.0815 1.34565 16 1.34565Z" fill="#54DBA3"/>
                                <path d="M14.0928 23.7985C13.6653 23.7985 13.2544 23.629 12.9514 23.326L5.69159 16.0662C5.06114 15.4357 5.06114 14.4149 5.69159 13.7845C6.32203 13.154 7.34282 13.154 7.97326 13.7845L14.0928 19.9041L23.9771 10.0197C24.6076 9.38926 25.6283 9.38926 26.2588 10.0197C26.8892 10.6502 26.8892 11.671 26.2588 12.3014L15.2343 23.326C14.9313 23.629 14.5217 23.7985 14.0928 23.7985Z" fill="white"/>
                                </svg>
                            </figure> 
                            <span class="label-static">Ja</span>
                        </div>
                    </div>
                    
                    <div
                        :class="['form-input-radio-button-big form-input-radio-button--danger', { 'active': smoking == false }]" 
                        id="no"
                        @click="smoking = false"
                        >
                        <div class="form-input-radio-button-inner">
                            <figure class="form-input-radio-button-icon">
                                <svg width="40" height="40" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5 31C24.7843 31 31.5 24.2843 31.5 16C31.5 7.71573 24.7843 1 16.5 1C8.21573 1 1.5 7.71573 1.5 16C1.5 24.2843 8.21573 31 16.5 31Z" fill="#FF3E57"/>
                                <path d="M10.1199 25C9.70499 25 9.29141 24.8415 8.97446 24.5258C8.34185 23.8932 8.34185 22.8689 8.97446 22.2363L22.736 8.47447C23.3686 7.84184 24.3929 7.84184 25.0255 8.47447C25.6582 9.10709 25.6582 10.1314 25.0255 10.764L11.264 24.5258C10.9483 24.8415 10.5334 25 10.1186 25H10.1199Z" fill="white"/>
                                <path d="M16.5 32C7.67759 32 0.5 24.8224 0.5 16C0.5 7.17759 7.67759 0 16.5 0C25.3224 0 32.5 7.17759 32.5 16C32.5 24.8224 25.3224 32 16.5 32ZM16.5 1.34564C8.41975 1.34564 1.84435 7.91975 1.84435 16.0013C1.84435 24.0828 8.41847 30.6569 16.5 30.6569C24.5815 30.6569 31.1556 24.0828 31.1556 16.0013C31.1556 7.91975 24.5815 1.34564 16.5 1.34564Z" fill="#FF3E57"/>
                                <path d="M23.8814 25C23.4666 25 23.053 24.8415 22.736 24.5258L8.97446 10.764C8.34185 10.1314 8.34185 9.10709 8.97446 8.47447C9.60707 7.84184 10.6314 7.84184 11.264 8.47447L25.0255 22.2363C25.6582 22.8689 25.6582 23.8932 25.0255 24.5258C24.7099 24.8415 24.295 25 23.8801 25H23.8814Z" fill="white"/>
                                </svg>
                            </figure> 
                            <span class="label-static">Nein</span>
                        </div>
                    </div>
                </div>

                <form-input-error v-if="errors.smoking && smoking === null" :error="errors.smoking[0]"></form-input-error>
            </div>

            <template v-if="smoking">
                <span class="form-input-title new-text-xl text-bold">Wenn ja, wie viele Zigaretten haben Sie an einem normalen Tag durchschnittlich geraucht?</span>

                <form-input-type-text-area
                    name="smoking_text"
                    :errors="errors.smoking_text"
                    :value="data && data.smoking === 'yes' && data['smoking_text'] ? data['smoking_text'] : ''"
                    full-border
                />
            </template>

            <v-button
                :label="type === 'first' ? 'Umfrage abschließen' : 'Weiter'"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                scrollPosition: null,
                errors: {
                    smoking: null,
                },
                isDisabled: true,
                smoking: null,
                radioList: [
                    {label: 'An wie vielen von den letzten SIEBEN TAGEN haben Sie sich gesund ernährt?', name: 'self-management_1', value: (this.data && parseInt(this.data['self-management_1'])) ?? null},
                    {label: 'An wie vielen TAGEN PRO WOCHE im letzten Monat haben Sie sich im Durchschnitt gesund ernährt?', name: 'self-management_2', value: (this.data && parseInt(this.data['self-management_2'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie 5 oder mehr Portionen Obst oder Gemüse gegessen?', name: 'self-management_3', value: (this.data && parseInt(this.data['self-management_3'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie fetthaltige Produkte wie rotes Fleisch oder nicht- fettreduzierte Milchprodukte gegessen?', name: 'self-management_4', value: (this.data && parseInt(this.data['self-management_4'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie sich mindestens 30 Minuten lang am Stück körperlich betätigt (auch Spazierengehen, Garten- oder Hausarbeit)?', name: 'self-management_5', value: (this.data && parseInt(this.data['self-management_5'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie Sport getrieben (z.B. Schwimmen, Nordic Walking, Radfahren)?', name: 'self-management_6', value: (this.data && parseInt(this.data['self-management_6'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie Ihren Blutzucker gemessen?', name: 'self-management_7', value: (this.data && parseInt(this.data['self-management_7'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie Ihren Blutzucker so oft gemessen, wie man es Ihnen von medizinischer Seite empfohlen hat?', name: 'self-management_8', value: (this.data && parseInt(this.data['self-management_8'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie Ihre Füße untersucht?', name: 'self-management_9', value: (this.data && parseInt(this.data['self-management_9'])) ?? null},
                    {label: 'An wie vielen der letzten SIEBEN TAGE haben Sie die Innenseite Ihrer Schuhe kontrolliert?', name: 'self-management_10', value: (this.data && parseInt(this.data['self-management_10'])) ?? null}
                ]
            }
        },

        mounted() {
            var that = this
            const scroll = this.$refs.scrollDiv
            
            scroll.addEventListener('scroll', () => {
                this.scrollPosition = scroll.scrollLeft;
            }, false)

            if(this.data) {
                if(this.data.smoking === 'yes') {
                    this.smoking = true
                } else if(this.data.smoking === 'no') {
                    this.smoking = false
                }
            }

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        methods: {
            clickOnRadio(name) {
                if(this.errors[name]) {
                    this.errors[name] = null
                    this.$forceUpdate();
                }
            }, 
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                    this.scrollToError()
                }
            },
            validate() {
                var that = this
                var checkedAll = true
                var smokingText = null

                for(let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name);
                    
                    var checkedRadio = Array.from(radioButtonGroup).find(
                        (radio) => radio.checked
                    );

                    if(checkedRadio === undefined) {
                        that.errors[radio.name] = ['Sie müssen mindestens eine Option auswählen.']
                    }
                }

                for(let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name);
                    
                    var checkedRadio = Array.from(radioButtonGroup).find(
                        (radio) => radio.checked
                    );

                    if(checkedRadio !== undefined) {
                        that.isDisabled = false
                        that.errors[radio.name] = null
                    } else {
                        that.isDisabled = true
                        checkedAll = false
                        break
                    }
                }

                if(this.smoking === null) {
                    this.errors.smoking = ['Sie müssen mindestens eine Option auswählen.']
                    this.isDisabled = true
                } else {
                    if(this.smoking) {
                        smokingText = document.getElementById('smoking_text')

                        if(smokingText.value === '') {
                            this.errors.smoking_text = ['Dieses Feld muss ausgefüllt werden.']
                            this.isDisabled = true
                        } else {
                            this.errors.smoking_text = null
                        }
                    } else {
                        this.errors.smoking = null
                    }
                }

                if(this.smoking !== null && checkedAll && smokingText !== null && smokingText.value === '') {
                    this.isDisabled = false
                }

                this.$forceUpdate();
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    is_completed: this.type === 'first' ? true : false,
                    answers: {
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '11' : '9'
                        }
                    }
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name);
                    
                    var checkedRadio = Array.from(radioButtonGroup).find(
                        (radio) => radio.checked
                    );

                    data.answers[radio.name] = {key: radio.name, value: checkedRadio.value.toString()}
                })

                data.answers.smoking = {key: 'smoking', value: this.smoking ? 'yes' : 'no'}

                if(this.smoking) {
                    var smokingText = document.getElementById('smoking_text')

                    data.answers.smoking_text = {key: 'smoking_text', value: smokingText.value}
                } else {
                    data.answers.smoking_text = {key: 'smoking_text', value: 'empty'}
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers,  true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError.previousElementSibling).offset().top - 180
                    },
                    800
                )
            },
            saveData() {
                var data = {
                    answers: {}
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name);
                    
                    var checkedRadio = Array.from(radioButtonGroup).find(
                        (radio) => radio.checked
                    );

                    data.answers[radio.name] = {key: radio.name, value: checkedRadio ? checkedRadio.value.toString() : null}
                })

                data.answers.smoking = {key: 'smoking', value: this.smoking ? 'yes' : 'no'}

                if(this.smoking) {
                    var smokingText = document.getElementById('smoking_text')

                    data.answers.smoking_text = {key: 'smoking_text', value: smokingText.value}
                } else {
                    data.answers.smoking_text = {key: 'smoking_text', value: 'empty'}
                }

                this.$emit('clicked', data.answers,  false)
            }
        }
    }
</script>
